import { z } from 'zod';

import chainData from 'blockscope/static/chainData';

const { evmAddressSchema, enrichedAddressSchema, evmTransactionHashSchema } =
  chainData;
const walletAddressMemoSchema = z.object({
  type: z.literal('wallet_address'),
  createdBy: z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  createdAt: z.string(),
  data: z.object({
    name: z.string(),
    address: evmAddressSchema,
    chain: z.string(),
    enrichedAddress: enrichedAddressSchema,
  }),
});
/** @typedef {z.infer<typeof walletAddressMemoSchema>} WalletAddressMemoSchema */

const contractAddressMemoSchema = z.object({
  type: z.literal('contract_address'),
  createdBy: z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  createdAt: z.string(),
  data: z.object({
    name: z.string(),
    address: evmAddressSchema,
    chain: z.string(),
    enrichedAddress: enrichedAddressSchema,
  }),
});
/** @typedef {z.infer<typeof contractAddressMemoSchema>} ContractAddressMemoSchema */

const contractAbiMemoSchema = z.object({
  type: z.literal('contract_abi'),
  createdBy: z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  createdAt: z.string(),
  data: z.object({
    name: z.string(),
    address: evmAddressSchema,
    chain: z.string(),
    enrichedAddress: enrichedAddressSchema,
  }),
});
/** @typedef {z.infer<typeof contractAbiMemoSchema>} ContractAbiMemoSchema */

const transactionMemoSchema = z.object({
  type: z.literal('transaction_hash'),
  createdBy: z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  createdAt: z.string(),
  data: z.object({
    description: z.string(),
    hash: evmTransactionHashSchema,
    chain: z.string(),
  }),
});
/** @typedef {z.infer<typeof transactionMemoSchema>} TransactionMemoSchema */

const investigationMemoSchema = z.discriminatedUnion('type', [
  walletAddressMemoSchema,
  contractAddressMemoSchema,
  contractAbiMemoSchema,
  transactionMemoSchema,
]);
/** @typedef {z.infer<typeof investigationMemoSchema>} InvestigationMemoSchema */

export const InvestigationMemosResponse = z.array(investigationMemoSchema);
/** @typedef {z.infer<typeof InvestigationMemosResponse>} InvestigationMemoResponseSchema */

export const InvestigationCreateParams = z.object({
  name: z.string().min(3, 'Name must be at least 3 characters'),
});

export const InvestigationCreateResponse = z.object({
  _id: z.string(),
  name: z.string(),
  createdAt: z.string().transform((str) => new Date(str)),
  updatedAt: z.string().transform((str) => new Date(str)),

  createdBy: z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
});

export const InvestigationResponse = z.object({
  _id: z.string(),
  name: z.string(),
  createdAt: z.string().transform((str) => new Date(str)),
  updatedAt: z.string().transform((str) => new Date(str)),

  createdBy: z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
});

export const InvestigationsResponse = z.array(InvestigationResponse);

/**
 * @typedef {z.infer<typeof InvestigationCreateParams>} IInvestigationCreateParams
 * @typedef {z.infer<typeof InvestigationResponse>} IInvestigationResponse
 */
